<template>
  <div class="card" :class="{'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
    <div class="card__container">
      <h1 class="account__title">Pembuatan Akun</h1>
      <p class="empty" :class="{error: errorMsg !== ''}">{{errorMsg}}</p>
      <p class="empty" :class="{success: successMsg !== ''}">{{successMsg}}</p>
      <div class="form__control">
        <label for="role">Role:</label>
        <select name="role" v-model="roleId" v-if="$store.state.user.job === 'Pemerintah'">
          <option value="0">Staff</option>
          <option value="1">Disnaker</option>
          <option value="2">Leader</option>
          <option value="3">Ajudan</option>
          <option value="4">Kepala Dinas</option>
          <option value="5">Walikota</option>
        </select>
        <select name="role" v-model="roleId" v-else-if="$store.state.user.job === 'EMS'">
          <option value="6">EMT</option>
          <option value="7">Trainee</option>
          <option value="8">Coass</option>
          <option value="9">Dokter Umum</option>
          <option value="10">Dokter Spesialis</option>
          <option value="11">Laboran</option>
          <option value="12">Koordinator SDM</option>
          <option value="13">Pimpinan</option>
        </select>
      </div>
      <div class="form__control">
        <label for="first_name">Nama Depan:</label>
        <input type="text" v-model="firstName" name="first_name" placeholder="Silahkan masukan nama depan staff" />
      </div>
      <div class="form__control">
        <label for="last_name">Nama Belakang:</label>
        <input type="text" v-model="lastName" name="last_name" placeholder="Silahkan masukan nama belakang staff" />
      </div>
      <div class="form__control">
        <label for="steamhex">Steam Hex:</label>
        <input type="text" v-model="steamHex" name="steamhex" placeholder="Silahkan masukan Steam Hex staff" />
      </div>
      <div class="form__control">
        <label for="username">Username:</label>
        <input type="text" v-model="username" name="username" placeholder="Silahkan masukan Username staff" />
      </div>
      <div class="form__control">
        <label for="password">password:</label>
        <input type="password" v-model="password" name="password" placeholder="Silahkan masukan Password staff" />
      </div>
      <div class="form__control">
        <label for="pekerjaan">Pekerjaan:</label>
        <input type="text" v-model="job" name="pekerjaan" :disabled="job !== ''" placeholder="Silahkan masukan pekerjaan staff" />
      </div>
      <div class="form__control form__control--submit">
        <button class="discard" :class="{animate: !checkValue}" @click.prevent="discardHandler()">Discard</button>
        <button @click.prevent="submitHandler()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
  import NewAccountController from '../../Controller/NewAccountController.vue';
  export default {
    extends: NewAccountController,
    data() {
      return {
        firstName: '',
        lastName: '',
        roleId: this.$store.state.user.job === 'Pemerintah' ? 0 : 6,
        steamHex: '',
        username: '',
        password: '',
        job: this.$store.state.user.job,
        errorMsg: '',
        successMsg: '',
      }
    },
    computed: {
      checkValue() {
        return this.firstName === '' && this.lastName === '' && this.steamHex === '' && this.username === '' && this.password === ''
      }
    },
    methods: {
      discardHandler() {
        this.roleId = this.$store.state.user.job === 'Pemerintah' ? 0 : 6;
        this.firstName = '';
        this.lastName = '';
        this.steamHex = '';
        this.username = '';
        this.password = '';
      },
      submitHandler() {
        if(!this.checkValue) {
          this.submitAccount(this.roleId, this.firstName, this.lastName, this.steamHex, this.username, this.password, this.job)
          .then(data => {
            if(data.status === 201) {
              this.discardHandler();
              this.errorMsg = '';
              this.successMsg = 'Akun berhasil di buat';
              setTimeout(() => {
                this.successMsg = '';
              }, 3000)
            } else {
              this.errorMsg = data.msg;
            }
          })
        } else {
          this.errorMsg = 'Kolom form tidak boleh kosong'
        }
      }
    },
  }
</script>

<style scoped>
  .account__title {
    font-size: 35px;
    margin-top: 40px;
  }
  .form__control {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 20px;
    font-size: 18px;
  }
  .form__control--submit {
    justify-content: space-between;
  }
  .form__control label {
    width: 200px;
    font-size: 25px;
  }

  .form__control input {
    margin: 0 0 0 20px;
    background: white;
    color: black;
    font-size: 18px;
    border: solid 1px #000;
    border-radius: 5px;
    padding: 5px 10px;
    width: 75%;
    height: 50px;
  }

  .form__control input::placeholder {
    color: rgb(134, 134, 134);
  }
  .form__control select {
    margin-left: 20px;
    font-size: 18px;
    padding: 10px;
    border-radius: 5px;
    color: black;
  }

  .form__control input:disabled {
    background: #ddd;
    border-color: rgba(118, 118, 118, 0.3);
  }

  .discard {
    opacity: 0;
    scale: 0;
    transition: all .2s;
  }

  .animate {
    opacity: 1;
    scale: 1;
  }

  .empty {
    display: none;
    margin-top: 20px;
    font-size: 20px;
    color: #ff5b5b;
  }
  
  .error, .success {
    display: block;
  }

  .success {
    color: white;
  }
</style>